import { CarriersService } from "@/services/CarriersService.js";

export const state = () => ({
  CarrierTypes: [],
  Carrier: {},
  Selected: null,
  activeTab: "",
  RelayPoint: null,
});

export const mutations = {
  setCarrierTypes(state, { data }) {
    state.CarrierTypes = data.Carriers;
    state.Carrier = data.Carrier;
  },
  // setAll(state, { data }) {
  //   state.Carriers = data.Carriers;
  //   state.Carrier = data.Carrier;
  // },
  setCarrier(state, { data }) {
    state.Carrier = { ...state.Carrier, ...data.Carrier };
  },
  setActiveTab(state, val) {
    state.activeTab = val;
  },
  setRelayPoint(state, val) {
    state.RelayPoint = val;
  },
};

export const actions = {
  fetchCarrierTypes(
    { commit },
    { idAddress, idCart, countryIsoCode, country, onSuccess = () => { }, onError = () => { } }
  ) {
    const carriersService = new CarriersService({
      http: this.$http,
      auth: this.$auth,
    });

    carriersService
      .getCarriers({
        idAddress,
        idCart,
        countryIsoCode,
        country,
        languageIsoCode: this.$i18n.locale,
        currencyIsoCode: this.$localisation.appCurrency.CurrencyIsoCode,
        responseLevel: "summary",
      })
      .then((data) => {
        commit("setCarrierTypes", { data });
        onSuccess(data);
      })
      .catch((err) => {
        onError(err);
      });
  },
  fetchCarriers(
    { commit },
    {
      idAddress,
      idCart,
      countryIsoCode,
      carrierType,
      responseLevel,
      postcode,
      city,
      address1,
      country,
      ip,
      onSuccess = () => { },
      onError = () => { },
    }
  ) {
    const carriersService = new CarriersService({
      http: this.$http,
      auth: this.$auth,
    });

    carriersService
      .getCarriers({
        idAddress,
        idCart,
        countryIsoCode,
        carrierType,
        responseLevel,
        languageIsoCode: this.$i18n.locale,
        currencyIsoCode: this.$localisation.appCurrency.CurrencyIsoCode,
        postcode,
        city,
        address1,
        country,
        ip,
      })
      .then((data) => {
        commit("setCarrier", { data });
        commit("setCarrierTypes", { data });
        onSuccess(data);
      })
      .catch((err) => {
        onError(err);
      });
  },
};
